// extracted by mini-css-extract-plugin
export default {"main":"Planning_main__Af19G"};